export default {
  title: "画像一覧",
  countLabel: "{count} 枚の画像",
  uploadFloating: "写真をアップロード",
  group: {
    referenceCount: "{count} styles",
  },
  referenceCreate: {
    ariaLabel: "別の参照で分析を作成",
    loadingTitle: "写真を準備しています",
    loadingMessage: "参照選択の前に元画像を復元しています。",
    failedTitle: "この写真を再利用できません",
    failedMessage:
      "ローカルキャッシュ画像を利用できません。もう一度アップロードしてください。",
    networkError:
      "ネットワークエラー：元画像を取得できませんでした。後でもう一度お試しください。",
  },
  dateFilter: {
    timeFilter: "日付で絞り込む",
    clearFilter: "日付フィルターを解除",
    allTime: "すべての期間",
    last7Days: "過去7日間",
    last30Days: "過去30日間",
    noData: "絞り込み可能な日付データがありません",
  },
  empty: {
    title: "画像が見つかりません",
    description: "アップロードするとここに表示されます",
    uploadAction: "アップロード",
    descriptionSuffix: "するとここに表示されます",
  },
  error: {
    title: "履歴を同期できませんでした",
    description: "サーバーに接続できず、画像を更新できませんでした。",
    retry: "再試行",
    uploadAction: "アップロード",
  },
  filteredEmpty: {
    title: "このフィルターに一致する画像はありません",
    description:
      "別の期間を指定するかフィルターを解除すると、すべての画像が表示されます。",
  },
  loading: "履歴を読み込み中",
  loadingMore: "さらに読み込み中",
  syncWarning:
    "履歴を完全に同期できませんでした。ローカルキャッシュの画像を表示しています。",
  deleteConfirm: {
    header: "削除の確認",
    message:
      "このアップロードグループと関連する参照記録を削除してもよろしいですか？この操作は元に戻せません。",
    accept: "削除",
    acceptPending: "削除中…",
    reject: "キャンセル",
    close: "閉じる",
  },
  sheet: {
    title: "画像の操作",
    openResult: "元の結果を開く",
    referenceList: "Styles",
    createReference: "別の参照で作成",
    delete: "この記録を削除",
    close: "閉じる",
    count: "{count} styles",
  },
};
